// Router
import { Routes } from "@/constants/routes"

// Translations
import { useTrans } from "@/i18n"

// UI
import { PageTemplateLink } from "@/layouts/PageTemplate"

// Hooks
import { useCurrentFinanceProject } from "../hooks/useCurrentFinanceProject"

// Types
import { ProjectTypeEnum } from "@/api/graphql"

// Constants
import { ProjectCrowdfundingTypes } from "@/constants/constants"

/**
 * FinanceProjectSubMenuTabs
 * @returns
 */
export function FinanceProjectSubMenuTabs() {
	// Translation
	const t = useTrans(["finance", "common"])

	// Get current finance project
	const { data: currentProject } = useCurrentFinanceProject()

	return (
		<>
			<PageTemplateLink
				to={`${Routes.FinanceProjects}/${currentProject.project?.id}`}
				name={t("common:common.navigation.finance.performance.link")}
				analyticsId={t(
					"common:common.navigation.finance.performance.link",
				)}
			/>
			<PageTemplateLink
				to={`${Routes.FinanceSolarInterestTariff}/${currentProject.project?.id}`}
				name={t(
					"common:common.navigation.finance.solar_interest_tariff.link",
				)}
				analyticsId={t(
					"common:common.navigation.finance.dashboard.link",
				)}
			/>

			{/** Show project owner loan info */}
			{ProjectCrowdfundingTypes.includes(
				currentProject?.project?.type as ProjectTypeEnum,
			) ? (
				<PageTemplateLink
					to={`${Routes.FinanceBondsLoan}/${currentProject?.project?.id}`}
					name={t("common:common.navigation.finance.bonds_loan.link")}
					analyticsId={t(
						"common:common.navigation.finance.bonds_loan.link",
					)}
				/>
			) : null}
		</>
	)
}
